// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2s8nb","row":"ProcedureTreatmentSummary_row__2aR2r"};